import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import { states } from '@/constants/lifecycle';
import { onCodeScroll } from '@/hooks/paging';
import SearchResultCardItems from './SearchResultCardItems';
import { performFind } from '../actions';
import SearchWarning from '../components/SearchWarning';

const SearchResultCards = ({
  category,
  code,
  compact,
  currentPage,
  fetchData,
  pageCount,
  results,
  warnings,
}) => {
  if (results.length === 0) {
    return null;
  }

  return (
    <>
      {warnings?.map((warning) => (<SearchWarning warning={warning} key={warning} />))}
      <InfiniteScrollCards
        className="aridhia-search-result-cards"
        entity="search.result"
        handleScroll={() => onCodeScroll(fetchData, category, code, currentPage, pageCount, 10)}
        items={results}
        itemsPerRow={1}
        loading
        readErrors={[]}
        readStatus={[states.SUCCESS]}
      >
        <SearchResultCardItems category={category} items={results} compact={compact} />
      </InfiniteScrollCards>
    </>
  );
};

const mapStateToProps = ({
  search: { searches },
}, { category, code }) => {
  const item = findResult(searches, category, code) || {
    results: [],
    currentPage: 1,
    totalPages: 0,
    warnings: [],
  };

  return (
    {
      results: item.results,
      currentPage: item.currentPage,
      pageCount: item.totalPages,
      warnings: item.warnings,
    }
  );
};

const mapDispatchToProps = {
  fetchData: (category, code, page, pageSize, append) => performFind(
    category,
    code,
    page,
    pageSize,
    append,
    null,
    null,
  ),
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultCards);
